import React, { useState, useEffect, useImperativeHandle, forwardRef } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  useTheme,
  Modal,
  CircularProgress,
  Button,
  Checkbox,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from "@mui/material";
import SearchableMultiSelect from "../../../../components/forms/Dropdowns/SearchableMultiSelect";
import PivotTableUI from "react-pivottable/PivotTableUI";
import "react-pivottable/pivottable.css";
import TableRenderers from "react-pivottable/TableRenderers";
import Plot from "react-plotly.js";
import createPlotlyRenderers from "react-pivottable/PlotlyRenderers";
import { LocalizationProvider } from "@mui/x-date-pickers-pro";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
import dayjs from "dayjs";
import { getHeaders } from "../../../../utils/apiUtils";
import { BASE_URL } from "../../../../config/apiConfig";
import useSize from "../../../../hooks/useSize";
import { showAlert } from "../../../../components/common/userFeedback/CustomAlert";
const PlotlyRenderers = createPlotlyRenderers(Plot);

const CataloguingProgressPivotTable = forwardRef(({fillPage=false, sx={}, width=null, height=null}, ref) => {
  const [cataloguingGarmLevelPivotData, setCataloguingGarmLevelPivotData] = useState([]);
  const [cataloguingGroupLevelPivotData, setCataloguingGroupLevelPivotData] = useState([]);
  const [pivotStateGarmLevel, setPivotStateGarmLevel] = useState({});
  const [pivotStateGroupLevel, setPivotStateGroupLevel] = useState({});
  const { palette, typography } = useTheme();
  const [date, setDate] = React.useState([dayjs().subtract(14, "day"), dayjs()]);
  const [dataLoading, setDataLoading] = useState(false);
  const [datasets, setDatasets] = useState([]);
  const [datasetId, setDatasetId] = useState(12);
  const [labels, setLabels] = useState([]);
  const windowSize = useSize();
  const chartWidth = fillPage ? 0.5*windowSize[0] : (width ?? 0.7*windowSize[0])
  const chartHeight = fillPage ? 0.3*windowSize[1] : (height ?? 0.25*windowSize[1])

  const refreshData = async () => {
    setCataloguingGarmLevelPivotData([]);
    setCataloguingGroupLevelPivotData([]);
    setDataLoading(true);

    let cataloguingProgressData = []
    if (labels.length > 0 && date)
    {
      console.log(`start`)
      cataloguingProgressData = await fetchData()
      console.log(`done`)
    }
    
    //https://github.com/plotly/react-pivottable/blob/master/examples/tips.js
    //https://github.com/plotly/react-pivottable/blob/master/examples/App.jsx
    //https://react-pivottable.js.org/ [Line Chart]
    const headers = ['metric','day','hour','count']
    const metricsGarmLevel = ['total_garms_available_for_cataloguing', 'total_catalogued_garms', 'total_catalogued_dataset_garms']
    const metricsGroupLevel = ['catalogue_length', 'total_groups_available_for_cataloguing', 'total_groups_catalogued']
    let dataGarmLevel = [headers]
    let dataGroupLevel = [headers]

    const arrayGroupLevel = []
    cataloguingProgressData.forEach(dataObj => {
      metricsGroupLevel.forEach(metric => {
        const obj = {
          metric: metric,
          day: dataObj['day'],
          hour: dataObj['hour'],
          count: dataObj[metric]
        }
        // array in same format as headers
        const arr = [metric, dataObj[metric], dataObj['day'], dataObj['hour']]
        arrayGroupLevel.push(obj)
        //array.push(arr)
      })
      //dataGroupLevel.push(array)
    })
    dataGroupLevel = arrayGroupLevel
    
    const arrayGarmLevel = []
    cataloguingProgressData.forEach(dataObj => {
      metricsGarmLevel.forEach(metric => {
        const obj = {
          metric: metric,
          day: dataObj['day'],
          hour: dataObj['hour'],
          count: dataObj[metric]
        }
        // array in same format as headers
        const arr = [metric, dataObj[metric], dataObj['day'], dataObj['hour']]
        arrayGarmLevel.push(obj)
        //array.push(arr)
      })
      //dataGarmLevel.push(array)
    })
    dataGarmLevel = arrayGarmLevel

    setCataloguingGroupLevelPivotData(dataGroupLevel);
    setCataloguingGarmLevelPivotData(dataGarmLevel);
  };

  useImperativeHandle(ref, () => {
    return {
      refreshData
    }
  })

  const handleDatasetChange = (event) => {
    setDatasetId(event.target.value);
  };

  useEffect(() => {
    const fetchDefaultBrands = async () => {
      let headers = await getHeaders();
      axios
        .get(`${BASE_URL}tools/general/filteroptions/listall/BRAND?search=off`, headers)
        .then((res) => {
          // Reset form fields (optional)
          const brandOffWhite = res.data.data.filter(brand => brand.id === 5063)
          setLabels([...brandOffWhite]);
        })
        .catch((err) => {
          showAlert(err);
        });
    };

    fetchDefaultBrands();
  }, []);

  useEffect(() => {
    const fetchDatasets = async () => {
      let headers = await getHeaders();
      axios
        .get(`${BASE_URL}tools/admin/datasets/listall`, headers)
        .then((res) => {
          // Reset form fields (optional)
          setDatasets([...res.data.data.filter(x => !x.is_archived)]);
        })
        .catch((err) => {
          showAlert(err);
        });
    };

    fetchDatasets();
  }, []);

  useEffect(() => {
    const aggregatorName = 'List Unique Values'
    const pivotStateGarmLevel = {
      data: cataloguingGarmLevelPivotData,
      rows: ['metric'],
      cols: ['hour'],
      aggregatorName: aggregatorName,
      vals: ['count'],
      rendererName: 'Line Chart',
      //sorters: {
      //    Meal: sortAs(['Lunch', 'Dinner']),
      //    'Day of Week': sortAs([
      //        'Thursday',
      //        'Friday',
      //        'Saturday',
      //        'Sunday',
      //    ]),
      //},
      plotlyOptions: {width: chartWidth, height: chartHeight}
      //plotlyConfig: {},
      //tableOptions: {
      //    clickCallback: function(e, value, filters, pivotData) {
      //        var names = [];
      //        pivotData.forEachMatchingRecord(filters, function(
      //            record
      //        ) {
      //            names.push(record.Meal);
      //        });
      //        alert(names.join('\n'));
      //    },
      //},
    }

    const pivotStateGroupLevel = {
      data: cataloguingGroupLevelPivotData,
      rows: ['metric'],
      cols: ['hour'],
      aggregatorName: aggregatorName,
      vals: ['count'],
      rendererName: 'Line Chart',
      //sorters: {
      //    Meal: sortAs(['Lunch', 'Dinner']),
      //    'Day of Week': sortAs([
      //        'Thursday',
      //        'Friday',
      //        'Saturday',
      //        'Sunday',
      //    ]),
      //},
      plotlyOptions: {width: chartWidth, height: chartHeight}
      //plotlyConfig: {},
      //tableOptions: {
      //    clickCallback: function(e, value, filters, pivotData) {
      //        var names = [];
      //        pivotData.forEachMatchingRecord(filters, function(
      //            record
      //        ) {
      //            names.push(record.Meal);
      //        });
      //        alert(names.join('\n'));
      //    },
      //},
    }

    setPivotStateGroupLevel(pivotStateGroupLevel)
    setPivotStateGarmLevel(pivotStateGarmLevel)
  }, [cataloguingGarmLevelPivotData, cataloguingGroupLevelPivotData])

  const fetchData = async () => {
    setDataLoading(true);
    try {
      let headers = await getHeaders();
      const response = await axios.post(
        `${BASE_URL}tools/analytics/pivots/cataloguing/cataloguing-progress`,
        {
          datasetId: datasetId,
          brandIds: labels.map(brand => brand.id),
          startDate: date[0].toISOString(),
          endDate: date[1].toISOString(),
        },
        headers
      );
      const newData = response.data.data;
      
      setDataLoading(false);
      return newData;
    } catch (error) {
      setDataLoading(false);
      console.error(`Error fetching proposals for Cataloguing Progress:`, error);
      showAlert(error);
      return []; // Return whatever was fetched before the error
    }
  };

  useEffect(() => {
    refreshData()
  }, [date, datasetId, labels])

  return (
    <>
      <Modal
        open={dataLoading}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <CircularProgress />
      </Modal>
      <Box
        sx={{
          display: "flex",
          width: "100%",
          overflow: "auto",
          p: 1,
          flexDirection: "column",
        }}
      >
        <Typography variant={fillPage ? "h2" : "h4"} sx={{
          p: 1, pt: 0
        }} color="primary.800">
          Cataloguing Progress Pivot Table
        </Typography>
        <Box
          sx={{
            p: 1,
            border: `1px solid ${palette.primary[200]}`,
            borderRadius: 1,
            flexDirection: "row",
            display: "flex",
          }}
        >
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DateRangePicker
              localeText={{ start: "Start", end: "End" }}
              onChange={(newValue) => setDate(newValue)}
              value={date}
            />
          </LocalizationProvider>

          
          <FormControl margin="normal" sx={{ ml: 2}}>
            <InputLabel shrink={true} id="dataset-label">
              Dataset
            </InputLabel>
            <Select
              labelId="dataset-label"
              id="dataset"
              label="Dataset"
              notched={true}
              value={datasetId}
              onChange={handleDatasetChange}
            >
              {datasets.map((dataset) => (
                <MenuItem value={dataset.id}>{dataset.name}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <SearchableMultiSelect
              sx={{ml: 2}}
              typeMapping={"BRAND"}
              selected={labels}
              onSelectedChange={setLabels}
              label={"Select Brand"}
            />

          {!ref && 
          <Box
            sx={{
              flex: 1,
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button variant="contained" onClick={refreshData}>
              Refresh
            </Button>
          </Box>}
          
        </Box>

        <Box
          sx={{
            mb: 1,
            p: 1,
            border: `1px solid ${palette.primary[200]}`,
            borderRadius: 1,
            ...sx
          }}
        >
          <Grid container>
            <Grid item xs className="pivottable-wide" sx={{mr: 2}}>
              <PivotTableUI
                onChange={setPivotStateGarmLevel}
                {...pivotStateGarmLevel}
                renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
              />
            </Grid>
            
            <Grid item xs className="pivottable-wide">
              <PivotTableUI
                onChange={setPivotStateGroupLevel}
                {...pivotStateGroupLevel}
                renderers={Object.assign({}, TableRenderers, PlotlyRenderers)}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>
    </>
  );
})

export default CataloguingProgressPivotTable;
